import { textFilter } from './actions/filter-provider';
import { getPagination } from './actions/pagination-provider';
import { IJPlistItem, IJPlistResult } from './artists-jplist-interfaces';

export const IGNORE_REGEX = '[^a-zA-Z0-9]+';

/**
 * apply all jPList action on the products list
 * filterTerm - the term that user entered in the text box
 * filterProperty - the field inside the product that the items will be filtered by
 *
 * sortType - text|number|datetime
 * sortProperty - the field inside the product that the items will be sorted by
 * sortOrder - asc or desc
 * nestedSortProperty - in case of equal items, sort them by 'nestedSortProperty'
 * purchased - https://wavesaudio.atlassian.net/browse/DSWEB-1798
 */
export const applyJPlist = (
        items: IJPlistItem[],
        category:any,

        // filter
        filterTerm: string,
        filterProperty: string,

        // pagination
        currentPage: number,
        itemsPerPage: number,
        range: number,

      /*  // sort
        sortType: string,
        sortProperty: string,
        sortOrder: string,
        nestedSortProperty: string = '',
*/
    ) : IJPlistResult => {

    let filtered = items;

    // filter the products by the user term
    filtered = textFilter(filtered, filterTerm, filterProperty);
    
    /*// sort
    filtered = sort(filtered, sortType, sortProperty, sortOrder, nestedSortProperty);*/

    // apply pagination

    const pagination = getPagination(currentPage, itemsPerPage, filtered.length, range);
    filtered = filtered.slice(pagination.start, pagination.end);

    return {
        pagination,
        artists: filtered,
    };
};
